import { render } from "./AdminPaymentclients.vue?vue&type=template&id=01bfecb4"
import script from "./AdminPaymentclients.vue?vue&type=script&lang=js"
export * from "./AdminPaymentclients.vue?vue&type=script&lang=js"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__